import React, {Component} from 'react';
import Select from "../../../local_node_modules/react-select"
import '../../../local_node_modules/react-select/dist/react-select.css';

import Select2, {Option} from 'rc-select';
import 'rc-select/assets/index.css';

import NumberFormat from 'react-number-format';
import {Decimal} from 'decimal.js';
import {
    Card,
    CardHeader,
    Col,
    Modal,
    ModalFooter,
    ModalHeader, Row,
    TabContent,
    TabPane,
    UncontrolledTooltip
} from 'reactstrap';
import {deepCopyObject} from "../../../helper/helper";
import {
    isValidBelgeLine,
    isValidDeliveryDetail,
    isValidInvoiceLine,
    isValidMgmDetail
} from "../../../common/componentValidation";
import {validateField} from "../../../common/validation";
import {getExemptions} from "../../../helper/invoiceHelper";
import Alert from "react-s-alert";
import {VirtualHost} from "../../../constants";
import moment from "moment";
import Datetime from "react-datetime";
import BelgeLines from "./BelgeLines";

class BelgeLineModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            error: {},
            activeTab: 'lineTab',
            kdvExemption: null,
            otvExemption: null
        };
        this.isOpen = this.isOpen.bind(this);
        this.validateField = this.validateField.bind(this);
        this.validateMessage = this.validateMessage.bind(this);
        this.validateClass = this.validateClass.bind(this);
        this.onChangeDeliveryDetail = this.onChangeDeliveryDetail.bind(this);
        this.getWithholdingPercentage = this.getWithholdingPercentage.bind(this);
        this.onChange = this.onChange.bind(this);
        this.addCharge = this.addCharge.bind(this);
        this.onChangeExemption = this.onChangeExemption.bind(this);
        this.setDeliveryDetail = this.setDeliveryDetail.bind(this);
        this.setMgmDetails = this.setMgmDetails.bind(this);
        this.setBelgeLine = this.setBelgeLine.bind(this);
        this.toggle = this.toggle.bind(this);
        this.getChargeWithCode = this.getChargeWithCode.bind(this);
        this.getExemption = this.getExemption.bind(this);
        this.removeCharge = this.removeCharge.bind(this);
        this.onChangeLineCharge = this.onChangeLineCharge.bind(this);
        this.onChangeAllowanceReason = this.onChangeAllowanceReason.bind(this);
        this.onValueChangeDeliveryDetail = this.onValueChangeDeliveryDetail.bind(this);
        this.onChangeDate = this.onChangeDate.bind(this);
    }

    componentDidMount() {
        let belgeLine = this.props.belgeLine;
        let kdvIndex = (belgeLine.trdDocBelgeLineCharges.map(function (charge) {
            return charge.taxCode.code;
        })).indexOf("0015");
        let otvIndex = (belgeLine.trdDocBelgeLineCharges.map(function (charge) {
            return charge.taxCode.code;
        })).indexOf("0071");

        if ((this.props.profileId === "IHRACAT") || (this.props.profileId === "EARSIVFATURA" && this.props.documentTypeCode === "ISTISNA")) {
            let deliveryDetail = belgeLine.trdDocBelgeLineDeliveryDetail ? deepCopyObject(belgeLine.trdDocBelgeLineDeliveryDetail) : null;
            if (!deliveryDetail) {
                deliveryDetail = {
                    actualPackageId: "",
                    actualPackagePTC: "1A",
                    actualPackageQuantity: "",
                    buildingName: "",
                    buildingNumber: "",
                    city: "",
                    citySubdivion: "",
                    country: "",
                    deliveryTerms: "DAF",
                    gtip: "",
                    packageBrand: "",
                    postalZone: "",
                    recordId: null,
                    shipmentId: "",
                    streetName: "",
                    transportMeansTypeCode: "",
                    transportModeCode: "1"
                };
                belgeLine.trdDocBelgeLineDeliveryDetail = deliveryDetail;
            }
        }

        this.setState({
            kdvExemption: (kdvIndex !== -1 ? belgeLine.trdDocBelgeLineCharges[kdvIndex].exemptionReasonCode : null),
            otvExemption: (otvIndex !== -1 ? belgeLine.trdDocBelgeLineCharges[otvIndex].exemptionReasonCode : null),
            modal: this.props.modal,
            belgeLine: belgeLine
        });
    }

    toggle(tab) {
        if (this.state.activeTab !== tab) {
            this.setState({activeTab: tab});
        }
    }

    validateField(e) {
        let id = e.target.id;
        let rule = e.target.dataset.vdata;
        let boundary = e.target.dataset.vlength;
        let result = validateField(rule, boundary, e.target.value);
        let error = this.state.error;
        error = Object.assign(error, {[id]: result});
        this.setState({error});
    }

    validateClass(id) {
        let error = this.state.error;
        return (error[id] === undefined ? "" : (error[id].valid ? " has-success" : " has-danger"));
    }

    validateMessage(id) {
        let error = this.state.error;
        return (error[id] === undefined ? '' : (error[id].message));
    }

    setBelgeLine(e, type) {
        e.preventDefault();
        let belgeLine = deepCopyObject(this.state.belgeLine);
        let result = isValidBelgeLine(belgeLine, this.props.profileId, this.props.documentTypeCode, this.props.isKamu());
        let error = result.error;
        let valid = result.valid;
        if (valid) {
            this.props.listener(belgeLine, type);
        } else {
            Alert.error(result.errorMessage, {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 3000
            });
            this.setState({error});
        }
    }

    //unused for the moment
    setMgmDetails(e) {
        e.preventDefault();
        if (this.state.activeTab !== "mgmTab") return;

        let {originCountryCode, classificationType, classificationValue} = this.state.belgeLine;

        let result = isValidMgmDetail(originCountryCode, classificationType, classificationValue);
        let error = result.error;
        let valid = result.valid;
        if (valid) {
            this.props.listenerMgmDetail(originCountryCode, classificationType, classificationValue);
        } else {
            Alert.error(result.errorMessage, {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 3000
            });
            this.setState({error});
        }
    }

    setDeliveryDetail(e) {
        e.preventDefault();
        let deliveryDetail = deepCopyObject(this.state.belgeLine.trdDocBelgeLineDeliveryDetail);
        let result = isValidDeliveryDetail(deliveryDetail);
        let error = result.error;
        let valid = result.valid;
        if (valid) {
            this.props.listenerDeliveryDetail(deliveryDetail);
        } else {
            Alert.error(result.errorMessage, {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 3000
            });
            this.setState({error});
        }
    }

    onChangeExemption(e) {
        let {name, value} = e;
        let belgeLine = deepCopyObject(this.state.belgeLine);
        let code = (name === "otvExemption" ? "0071" : "0015");
        let index = (belgeLine.trdDocBelgeLineCharges.map(function (charge) {
            return charge.taxCode.code;
        })).indexOf(code);

        if (index === -1) {
            let message = (code === "0015" ? "KDV istisnası ekleyebilmek için KDV GERCEK vergisi eklenmelidir."
                : "ÖTV istisnası ekleyebilmek için ÖTV 1.LİSTE vergisi eklenmelidir.");
            Alert.error(message, {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 5000
            });
        } else {
            if (this.props.documentTypeCode !== "IHRACKAYITLI") {
                belgeLine.trdDocBelgeLineCharges[index].percentage = 0.00;
                belgeLine.trdDocBelgeLineCharges[index].amount = 0.00;
            }
            belgeLine.trdDocBelgeLineCharges[index].exemptionReasonCode = value;
            belgeLine.trdDocBelgeLineCharges[index].exemptionReason = value ? this.getExemption(value).longCode : null;
            this.setState({[name]: value, belgeLine: belgeLine});
        }
    }

    onChange(e) {
        let belgeLine = deepCopyObject(this.state.belgeLine);
        belgeLine[e.target.name] = (e.target.name === "quantity" || e.target.name === "unitPrice") ? (new Decimal(e.target.value)).toNumber() : e.target.value;
        if (e.name !== "itemName" &&
            e.name !== "gumrukTakipNo" &&
            e.name !== "unit") {
            belgeLine = BelgeLines.calculate(belgeLine, (this.props.isRoundKDV ? Decimal.ROUND_UP : Decimal.ROUND_HALF_UP), this.props.fromTotalToUnit);
        }
        this.setState({belgeLine});
    }

    removeCharge(index) {
        let belgeLine = deepCopyObject(this.state.belgeLine);
        let lineCharges = belgeLine.trdDocBelgeLineCharges;
        let otvExemption = lineCharges[index].taxCode.code === "0071" ? null : this.state.otvExemption;
        lineCharges.splice(index, 1);
        belgeLine.trdDocBelgeLineCharges = lineCharges;
        belgeLine = BelgeLines.calculate(belgeLine, (this.props.isRoundKDV ? Decimal.ROUND_UP : Decimal.ROUND_HALF_UP), this.props.fromTotalToUnit);
        this.setState({belgeLine, otvExemption: otvExemption});
    }

    addCharge(e) {
        let selectedChargeCode = e.value;
        let selectedCharge = this.getChargeWithCode(selectedChargeCode);
        let belgeLine = deepCopyObject(this.state.belgeLine);
        let control = [];
        belgeLine.trdDocBelgeLineCharges.map(charge => {
            control.push(charge.taxCode.code);
        });
        if ((belgeLine.trdDocBelgeLineCharges.map(function (charge) {
            return charge.taxCode.code;
        })).indexOf(selectedChargeCode) === -1) {
            if ((selectedChargeCode === "0003" && control.includes("0011")) || (selectedChargeCode === "0011" && control.includes("0003"))) {
                Alert.error("Gelir Vergisi Stopajı ve Kurumlar Vergisi Stopajını aynı zamanda ekleyemezsiniz.", {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 5000
                });
            } else {
                if (selectedChargeCode === "9015" && (this.props.documentTypeCode !== "IADE" && this.props.documentTypeCode !== "SGK" && this.props.documentTypeCode !== "TEVKIFAT")) {
                    Alert.error("KDV Tevkifat vergisi içeren faturaların Türü IADE, SGK veya TEVKIFAT olmalıdır.", {
                        position: 'top-right',
                        effect: 'stackslide',
                        timeout: 5000
                    });

                } else {
                    let tCharges = belgeLine.trdDocBelgeLineCharges;
                    tCharges.push({
                        recordId: null,
                        amount: 0,
                        calculatedBy: selectedCharge.calculatedBy,
                        direction: selectedCharge.direction,
                        priority: selectedCharge.priority,
                        exemptionReasonCode: null,
                        percentage: 0.0,
                        perUnitAmount: 0.0,
                        taxCode: selectedCharge,
                        belgeLineId: null,
                        withholdingCode: null,
                        allowanceReason: null
                    });
                    tCharges.map(charge => {
                        if (charge.taxCode.code === "0003" || charge.taxCode.code === "0011") {
                            charge.nakitTeminati = 0;
                            charge.avansMahsubu = 0;
                        }
                    })
                    tCharges.sort((charge1, charge2) => charge1.taxCode.priority - charge2.taxCode.priority);
                    belgeLine.trdDocBelgeLineCharges = tCharges;
                    this.setState({belgeLine: belgeLine, selectedChargeCode: undefined});
                }
            }
        } else {
            this.setState({selectedChargeCode: undefined});
            Alert.error(selectedCharge.shortName + ' vergisi zaten eklidir.', {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 5000
            });
        }
    }

    onChangeAllowanceReason(value, index) {
        let belgeLine = deepCopyObject(this.state.belgeLine);
        belgeLine.trdDocBelgeLineCharges[index].allowanceReason = value;
        this.setState({belgeLine});
    }

    onChangeMgmFields(e) {
        let belgeLine = deepCopyObject(this.state.belgeLine); //  ¿ porque es esto necesario ?
        belgeLine[e.target.id] = e.target.value;
        this.setState({belgeLine});
    }

    onChangeDeliveryDetail(e) {
        if (e.target && e.target.id && e.target.value && e.target.id === "postalZone" && isNaN(e.target.value)) {
        } else {
            let belgeLine = deepCopyObject(this.state.belgeLine);
            belgeLine["trdDocBelgeLineDeliveryDetail"][e.target.id] = e.target.value;
            this.setState({belgeLine});
        }
    }

    onValueChangeDeliveryDetail(e, name) {
        let value = e.value;
        let belgeLine = deepCopyObject(this.state.belgeLine);
        belgeLine["trdDocBelgeLineDeliveryDetail"][name] = value;
        this.setState({belgeLine});
    }

    onChangeLineCharge(value, chargeIndex, calculatedBy) {
        let belgeLine = deepCopyObject(this.state.belgeLine);
        let trdDocBelgeLineCharges = deepCopyObject(belgeLine.trdDocBelgeLineCharges);
        if (calculatedBy === "withholdingCode") {
            let res = value.split("_");
            let code1 = res[0];
            trdDocBelgeLineCharges[chargeIndex]["percentage"] = this.getWithholdingPercentage(value);
            trdDocBelgeLineCharges[chargeIndex][calculatedBy] = code1;
        } else{
            /*            if(calculatedBy === "650"){
                            this.props.withholdingTypes.map(withholdingType => {
                                if(withholdingType.code === "650"){
                                    withholdingType.percentage = new Decimal(value).toNumber();
                                }
                            })
                            calculatedBy = "percentage";
                        }*/
            trdDocBelgeLineCharges[chargeIndex][calculatedBy] = new Decimal(value).toNumber();
        }
        trdDocBelgeLineCharges[chargeIndex]["calculateFrom"] = calculatedBy;
        belgeLine.trdDocBelgeLineCharges = deepCopyObject(trdDocBelgeLineCharges);
        belgeLine = BelgeLines.calculate(belgeLine, (this.props.isRoundKDV ? Decimal.ROUND_UP : Decimal.ROUND_HALF_UP), this.props.fromTotalToUnit);
        this.setState({belgeLine});
    }

    getChargeWithCode(code) {
        let charge = this.props.charges.find(function (charge) {
            return charge.code === code;
        });
        return charge;
    }

    getWithholdingPercentage(code) {
        let res = code.split("_");
        let code1 = res[0];
        let percentage1 = res[1];
        let withholdingType = this.props.withholdingTypes.find(function (withholdingType) {
            return withholdingType.code === code1 && withholdingType.percentage == percentage1;
        });
        return withholdingType.percentage;
    }

    getExemption(code) {
        let exemption = this.props.exemptions.find(function (exemption) {
            return exemption.numberCode === code;
        });
        return exemption;
    }

    isOpen() {
        this.props.listener(this.props.belgeLine, "close");
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.belgeLine !== nextProps.belgeLine) {
            this.setState({belgeLine: nextProps.belgeLine});
        }
    }

    onChangeDate(momentObj, type, fieldName) {

        let value;
        let belgeLine = deepCopyObject(this.state.belgeLine);
        let {error} = this.state;
        if (!(typeof momentObj === "string")) {

            value = momentObj.format("YYYY-MM-DD");
            error[fieldName] = undefined

        } else {
            value = moment(momentObj,"YYYY-MM-DD");
            error[fieldName] = {className: "is-invalid", message: "Tarih formatı hatalı. GG-AA-YYYY biçimine uyunuz."}

        }
        belgeLine[fieldName] = value;
        this.setState({belgeLine, error})
    }

    render() {

        let belgeLine = this.state.belgeLine;

        if (!belgeLine) return null;

        let deliveryDetail = this.state.belgeLine.trdDocBelgeLineDeliveryDetail;
        let {originCountryCode, classificationType, classificationValue} = this.state.belgeLine;

        return (
            <Modal isOpen={this.state.modal} toggle={this.isOpen} size="lg" backdrop={false}>
                <ModalHeader toggle={this.isOpen}>{(this.props.index + 1) + "."} Satır Bilgileri</ModalHeader>
                <Card className="">
                    <CardHeader>
                        <div className="nav-tabs-navigation">
                            <div className="nav-tabs-wrapper">
                                <ul className="nav tabBackground nav-tabs" data-tabs="tabs">
                                    <li className="nav-item">
                                        <a className={"nav-link " + (this.state.activeTab === 'lineTab' ? 'active' : '')}
                                           onClick={() => {
                                               this.toggle('lineTab');
                                           }}
                                           data-toggle="tab">Genel Bilgiler</a>
                                    </li>
                                    {this.props.isKamu() &&
                                    <li className="nav-item">
                                        <a className={"nav-link " + (this.state.activeTab === 'mgmTab' ? 'active' : '')}
                                           onClick={() => {
                                               this.toggle('mgmTab');
                                           }}
                                           data-toggle="tab">MGM Ek Bilgiler</a>
                                    </li>
                                    }
                                    {this.props.profileId === "IHRACAT" &&
                                    <li className="nav-item">
                                        <a className={"nav-link " + (this.state.activeTab === 'deliveryTab' ? 'active' : '')}
                                           onClick={() => {
                                               this.toggle('deliveryTab');
                                           }}
                                           data-toggle="tab">Teslimat Bilgileri</a>
                                    </li>
                                    }
                                </ul>
                                <hr></hr>
                            </div>
                        </div>
                    </CardHeader>
                    <TabContent activeTab={this.state.activeTab}>
                        <TabPane tabId="lineTab">
                            <div className=" row col-sm-12" style={{marginLeft: '0px', marginTop: '20px'}}>
                                <div className="col-sm-6 ">
                                    <div className="row">
                                        <label className="col-sm-4 col-form-label">Ürün Adı</label>
                                        <div className="col-sm-8">
                                            <div className={"form-group" + this.validateClass('itemName')}>
                                                <input id="itemName"
                                                       name="itemName"
                                                       type="text"
                                                       data-vlength="1,255"
                                                       className="form-control"
                                                       onBlur={this.validateField}
                                                       placeholder="Ürün Adı" value={belgeLine.itemName}
                                                       onChange={(e) => this.onChange(e)}/>
                                                {this.validateMessage('itemName') !== "" &&
                                                <UncontrolledTooltip placement="right" target={'itemName'}
                                                                     delay={0}>
                                                    {this.validateMessage('itemName')}
                                                </UncontrolledTooltip>}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <label className="col-sm-4 col-form-label">Miktar</label>
                                        <div className="col-sm-8">
                                            <div className="form-group">
                                                <NumberFormat id={'quantity'}
                                                              value={belgeLine.quantity}
                                                              allowNegative={false}
                                                              isNumericString={true}
                                                              allowEmptyFormatting={false}
                                                              decimalScale={9}
                                                              thousandSeparator={'.'}
                                                              decimalSeparator={','}
                                                              displayType="input"
                                                              isAllowed={values => {
                                                                  return (values.value === "" ? false : true);
                                                              }}
                                                              placeholder="quantity"
                                                              renderText={value => {
                                                                  value.replace(/\./g, ',')
                                                              }}
                                                              onValueChange={(e) => this.onChange({
                                                                  target: {
                                                                      value: e.value,
                                                                      name: "quantity"
                                                                  }
                                                              })}
                                                              className="form-control"/>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="row">
                                        <label className="col-sm-4 col-form-label">Birim Fiyat</label>
                                        <div className="col-sm-8">
                                            <div className="form-group">
                                                <NumberFormat id={'unitPrice'}
                                                              value={belgeLine.unitPrice}
                                                              allowNegative={true}
                                                              isNumericString={true}
                                                              allowEmptyFormatting={false}
                                                              decimalScale={9}
                                                              thousandSeparator={'.'}
                                                              decimalSeparator={','}
                                                              displayType="input"
                                                              isAllowed={values => {
                                                                  return (values.value === "" ? false : true);
                                                              }}
                                                              placeholder="unitPrice"
                                                              renderText={value => {
                                                                  value.replace(/\./g, ',')
                                                              }}
                                                              onValueChange={(e) => this.onChange({
                                                                  target: {
                                                                      value: e.value,
                                                                      name: "unitPrice"
                                                                  }
                                                              })}
                                                              className="form-control"/>
                                            </div>
                                        </div>
                                    </div>

                                    {VirtualHost.conf.resourcePrefix === "eczacikart" &&
                                    <div className=" row">

                                        <label className="col-sm-4 col-form-label">Etiket Fiyatı</label>
                                        <div className="col-sm-8">
                                            <div className="form-group">
                                                <NumberFormat id="tagPrice"
                                                              value={belgeLine.tagPrice}
                                                              allowNegative={false}
                                                              isNumericString={true}
                                                              decimalScale={2}
                                                              thousandSeparator={'.'}
                                                              decimalSeparator={','}
                                                              suffix={"₺"}
                                                              displayType="input"
                                                              renderText={value => {
                                                                  value.replace(/\./g, ',')
                                                              }}
                                                              onValueChange={(e) => this.onChange({
                                                                  target: {
                                                                      value: e.value,
                                                                      name: "tagPrice"
                                                                  }
                                                              })}
                                                              className="form-control"/>
                                            </div>
                                        </div>
                                    </div>
                                    }

                                    {VirtualHost.conf.resourcePrefix === "eczacikart" &&
                                    <div className=" row">

                                        <label className="col-sm-4 col-form-label">Kurum İskontosu</label>
                                        <div className="col-sm-8">
                                            <div className="form-group">
                                                <NumberFormat id="publicDiscount"
                                                              value={belgeLine.publicDiscount}
                                                              allowNegative={false}
                                                              isNumericString={true}
                                                              decimalScale={2}
                                                              thousandSeparator={'.'}
                                                              decimalSeparator={','}
                                                              suffix={"₺"}
                                                              displayType="input"
                                                              renderText={value => {
                                                                  value.replace(/\./g, ',')
                                                              }}
                                                              onValueChange={(e) => this.onChange({
                                                                  target: {
                                                                      value: e.value,
                                                                      name: "publicDiscount"
                                                                  }
                                                              })}
                                                              className="form-control"/>
                                            </div>
                                        </div>
                                    </div>
                                    }

                                    {((this.props.profileId === "HKS" && this.props.documentTypeCode === "SATIS") ||
                                        this.props.documentTypeCode === "HKSSATIS") &&
                                    <div className="row">
                                        <label className="col-sm-4 col-form-label">Mal Sahibi</label>
                                        <div className="col-sm-8">
                                            <div className={"form-group" + this.validateClass('malSahibi')}>
                                                <input id="malSahibi"
                                                       name="malSahibi"
                                                       type="text"
                                                       data-vlength="0,255"
                                                       className="form-control"
                                                       onBlur={this.validateField}
                                                       placeholder="Mal Sahibi giriniz" value={belgeLine.malSahibi}
                                                       onChange={(e) => this.onChange(e)}/>
                                                {this.validateMessage('malSahibi') !== "" &&
                                                <UncontrolledTooltip placement="right" target={'malSahibi'}
                                                                     delay={0}>
                                                    {this.validateMessage('malSahibi')}
                                                </UncontrolledTooltip>}
                                            </div>
                                        </div>
                                    </div>}


                                </div>

                                <div className="col-sm-6 ">

                                    <div className="row">
                                        <label className="col-sm-4 col-form-label">Birim</label>
                                        <div className="col-sm-8">
                                            <div className="form-group">
                                                <Select2
                                                    id="unit"
                                                    placeholder="Birim Seçiniz"
                                                    defaultValue="C62"
                                                    value={belgeLine.unit}
                                                    style={{width: "100%"}}
                                                    dropdownMenuStyle={{maxHeight: 200}}
                                                    optionLabelProp="children"
                                                    notFoundContent="Kayıt bulunamadı"
                                                    optionFilterProp="text"
                                                    getPopupContainer={(node) => {
                                                        return node.parentNode;
                                                    }}
                                                    onChange={(e) => this.onChange({
                                                        target: {
                                                            value: e,
                                                            name: "unit"
                                                        }
                                                    })}>
                                                    {this.props.unitCodes.map(unitCode =>
                                                        <Option text={unitCode.longCode} value={unitCode.shortCode}
                                                                title={unitCode.longCode}>{unitCode.longCode}</Option>
                                                    )}
                                                </Select2>
                                            </div>
                                        </div>
                                    </div>

                                    <div className=" row">

                                        <label className="col-sm-4 col-form-label">Ürün/Hizmet Tutarı</label>
                                        <div className="col-sm-8">
                                            <div className="form-group">
                                                <NumberFormat id="lineExtensionAmount"
                                                              value={belgeLine.lineExtensionAmount}
                                                              allowNegative={false}
                                                              isNumericString={true}
                                                              decimalScale={2}
                                                              thousandSeparator={'.'}
                                                              decimalSeparator={','}
                                                              suffix={this.props.suffix}
                                                              disabled
                                                              displayType="input"
                                                              isAllowed={values => {
                                                                  return (values.value === "" ? false : true);
                                                              }}
                                                              placeholder="lineExtensionAmount"
                                                              renderText={value => {
                                                                  value.replace(/\./g, ',')
                                                              }}
                                                              onValueChange={(e) => this.onChange({
                                                                  target: {
                                                                      value: e.value,
                                                                      name: "lineExtensionAmount"
                                                                  }
                                                              })}
                                                              className="form-control"/>
                                            </div>
                                        </div>
                                    </div>

                                    {VirtualHost.conf.resourcePrefix === "eczacikart" &&
                                    <div className=" row">

                                        <label className="col-sm-4 col-form-label">Eczacı Kâr Oranı</label>
                                        <div className="col-sm-8">
                                            <div className="form-group">
                                                <NumberFormat id="pharmacistProfit"
                                                              value={belgeLine.pharmacistProfit}
                                                              allowNegative={false}
                                                              isNumericString={true}
                                                              decimalScale={2}
                                                              thousandSeparator={'.'}
                                                              decimalSeparator={','}
                                                              suffix={"%"}
                                                              displayType="input"
                                                              renderText={value => {
                                                                  value.replace(/\./g, ',')
                                                              }}
                                                              onValueChange={(e) => this.onChange({
                                                                  target: {
                                                                      value: e.value,
                                                                      name: "pharmacistProfit"
                                                                  }
                                                              })}
                                                              className="form-control"/>
                                            </div>
                                        </div>
                                    </div>
                                    }

                                    {VirtualHost.conf.resourcePrefix === "eczacikart" &&
                                    <div className=" row">

                                        <label className="col-sm-4 col-form-label">Vade</label>
                                        <div className="col-sm-8">
                                            <div className="form-group">
                                                <Datetime locale="tr"
                                                          inputProps={{
                                                              id: "expiry",
                                                              class: ("form-control")
                                                          }}
                                                          className="datepicker"
                                                          input={true}
                                                          closeOnSelect={true}
                                                          value={moment(belgeLine.expiry, "YYYY-MM-DD", true).isValid() ? moment(belgeLine.expiry).format("DD-MM-YYYY")
                                                              : belgeLine.expiry}
                                                          dateFormat="DD-MM-YYYY"
                                                          timeFormat={false}
                                                          onChange={(e) => this.onChangeDate(e, "date", "expiry")}/>

                                            </div>
                                        </div>
                                    </div>
                                    }

                                    {VirtualHost.conf.resourcePrefix === "eczacikart" &&
                                    <div className=" row">

                                        <label className="col-sm-4 col-form-label">Depocu Fiyatı</label>
                                        <div className="col-sm-8">
                                            <div className="form-group">
                                                <NumberFormat id="storePrice"
                                                              value={belgeLine.storePrice}
                                                              allowNegative={false}
                                                              isNumericString={true}
                                                              decimalScale={2}
                                                              thousandSeparator={'.'}
                                                              decimalSeparator={','}
                                                              suffix={"₺"}
                                                              displayType="input"
                                                              renderText={value => {
                                                                  value.replace(/\./g, ',')
                                                              }}
                                                              onValueChange={(e) => this.onChange({
                                                                  target: {
                                                                      value: e.value,
                                                                      name: "storePrice"
                                                                  }
                                                              })}
                                                              className="form-control"/>
                                            </div>
                                        </div>
                                    </div>
                                    }
                                    {(this.props.documentTypeCode === "ISTISNA") &&
                                        <div className="row">
                                            <label className="col-sm-4 col-form-label">GTİP Numarası</label>
                                            <div className="col-sm-8">
                                                <div className={"form-group" + this.validateClass("gtip")}>
                                                    <input className="form-control"
                                                           type="text"
                                                           id="gtip"
                                                           name="gtip"
                                                           maxLength="12"
                                                           data-vdata="gtip"
                                                           data-vlength="12,12"
                                                           onBlur={this.validateField}
                                                           value={belgeLine.gtip}
                                                           onChange={(e) => this.onChange(e)}/>
                                                    {this.validateMessage('gtip') !== "" &&
                                                        <UncontrolledTooltip placement="right" target="gtip" delay={0}>
                                                            {this.validateMessage("gtip")}
                                                        </UncontrolledTooltip>}
                                                </div>
                                            </div>
                                        </div>
                                    }
                                    <div className="row">
                                        <label className="col-sm-4 col-form-label">Satır Açıklaması</label>
                                        <div className="col-sm-8">
                                            <div className={"form-group" + this.validateClass('lineExplanation')}>
                                                <input id="lineExplanation"
                                                       name="lineExplanation"
                                                       type="text"
                                                       data-vlength="1"
                                                       maxLength="255"
                                                       className="form-control"
                                                       onBlur={this.validateField}
                                                       placeholder="Satır Açıklaması"
                                                       value={belgeLine.lineExplanation}
                                                       onChange={(e) => this.onChange(e)}/>
                                                {this.validateMessage('lineExplanation') !== "" &&
                                                <UncontrolledTooltip placement="right" target={'lineExplanation'}
                                                                     delay={0}>
                                                    {this.validateMessage('lineExplanation')}
                                                </UncontrolledTooltip>}
                                            </div>
                                        </div>
                                    </div>

                                    {(this.props.profileId === "IHRACAT" || this.props.profileId === "YOLCUBERABERFATURA") &&

                                    <div className="row">
                                        <label className="col-sm-4 col-form-label">Gümrük Takip No</label>
                                        <div className="col-sm-8">
                                            <div className={"form-group" + this.validateClass('gumrukTakipNo')}>
                                                <input id="gumrukTakipNo"
                                                       name="gumrukTakipNo"
                                                       type="text"
                                                       data-vlength="0,255"
                                                       className="form-control"
                                                       onBlur={this.validateField}
                                                       placeholder="gumrukTakipNo" value={belgeLine.gumrukTakipNo}
                                                       onChange={(e) => this.onChange(e)}/>
                                                {this.validateMessage('gumrukTakipNo') !== "" &&
                                                <UncontrolledTooltip placement="right" target={'gumrukTakipNo'}
                                                                     delay={0}>
                                                    {this.validateMessage('gumrukTakipNo')}
                                                </UncontrolledTooltip>}
                                            </div>
                                        </div>
                                    </div>

                                    }
                                    {((this.props.profileId === "HKS" && this.props.documentTypeCode === "SATIS") ||
                                        this.props.documentTypeCode === "HKSSATIS") &&
                                    <div className="row">
                                        <label className="col-sm-4 col-form-label">Mal Sahibi Vkn/Tckn</label>
                                        <div className="col-sm-8">
                                            <div className={"form-group" + this.validateClass('malSahibiVkntckn')}>
                                                <input id="malSahibiVkntckn"
                                                       name="malSahibiVkntckn"
                                                       type="text"
                                                       data-vlength="0,255"
                                                       className="form-control"
                                                       onBlur={this.validateField}
                                                       placeholder="Mal Sahibi Vkn/Tckn giriniz"
                                                       value={belgeLine.malSahibiVkntckn}
                                                       onChange={(e) => this.onChange(e)}/>
                                                {this.validateMessage('malSahibiVkntckn') !== "" &&
                                                <UncontrolledTooltip placement="right" target={'malSahibiVkntckn'}
                                                                     delay={0}>
                                                    {this.validateMessage('malSahibiVkntckn')}
                                                </UncontrolledTooltip>}
                                            </div>
                                        </div>
                                    </div>}

                                    { (this.props.profileId === "EARSIVFATURA" && this.props.documentTypeCode === "ISTISNA")&&
                                    <div className="row">
                                        <label className="col-sm-4 col-form-label">GTİP Numarası* </label>
                                        <div className="col-sm-8">
                                            <div className={"form-group" + this.validateClass("gtip")}>
                                                <input className="form-control"
                                                       type="text"
                                                       id="gtip"
                                                       name="gtip"
                                                       maxLength="12"
                                                       data-vdata="gtip"
                                                       data-vlength="12,12"
                                                       onBlur={this.validateField}
                                                       value={deliveryDetail.gtip}
                                                       onChange={(e) => this.onChangeDeliveryDetail(e)}/>
                                                {this.validateMessage('gtip') !== "" &&
                                                <UncontrolledTooltip placement="right" target="gtip" delay={0}>
                                                    {this.validateMessage("gtip")}
                                                </UncontrolledTooltip>}
                                            </div>
                                        </div>
                                    </div>
                                    }
                                </div>


                            </div>


                            <hr/>
                            <Row>
                                <Col xs="12" style={{display: "flex", padding: "1% 7% 2% 7%"}}>
                                    <Select2
                                        placeholder="Eklenecek Vergiyi Seçiniz"
                                        value={this.state.selectedChargeCode}
                                        style={{width: "60%"}}
                                        dropdownMenuStyle={{maxHeight: 200}}
                                        optionLabelProp="children"
                                        optionFilterProp="text"
                                        notFoundContent="Kayıt bulunamadı"
                                        getPopupContainer={(node) => {
                                            return node.parentNode;
                                        }}
                                        onChange={(e) => this.addCharge({value: e})}>
                                        {this.props.charges.filter((charge => charge.code !== "0000" && charge.code !== "0015" && charge.code !== "SGK_PRIM" && charge.code !== "0001" && !(charge.code > "2000" && charge.code < "4000"))).map(charge =>
                                            <Option text={charge.shortName} value={charge.code}
                                                    title={charge.shortName}>{charge.shortName}</Option>
                                        )}
                                    </Select2>

                                    <Select2
                                        placeholder="Eklenecek İskontoyu Seçiniz"
                                        value={this.state.selectedChargeCode}
                                        style={{width: "60%"}}
                                        dropdownMenuStyle={{maxHeight: 200}}
                                        optionLabelProp="children"
                                        optionFilterProp="text"
                                        notFoundContent="Kayıt bulunamadı"
                                        getPopupContainer={(node) => {
                                            return node.parentNode;
                                        }}
                                        onChange={(e) => this.addCharge({value: e})}>
                                        {this.props.charges.filter((charge => charge.code === "0000" || charge.code === "0001" || (charge.code > "2000" && charge.code < "4000"))).map(charge =>
                                            <Option text={charge.shortName} value={charge.code}
                                                    title={charge.shortName}>{charge.shortName}</Option>
                                        )}
                                    </Select2>
                                </Col>
                            </Row>


                            <div className="row col-sm-12">
                                <div className="col-md-2"/>

                                <div className="col-sm-3">
                                    <label>Oran (%) veya Birim Fiyatı (₺)</label>
                                </div>

                                <div className="col-md-3">
                                    <label>Tutar (₺)</label>
                                </div>

                                <div className="col-md-4">
                                    <label>İskonto / Artırım Sebebi</label>
                                </div>
                            </div>
                            {belgeLine.trdDocBelgeLineCharges.map((charge, j) =>
                                <div className="row col-sm-12" key={"key_" + j}>
                                    <div className="col-md-2">
                                        <label
                                            className="col-form-label">{charge.taxCode.shortName + (charge.taxCode.code === "9015" ? "( " + charge.percentage + "% )" : "")}</label>
                                    </div>
                                    {charge.taxCode.code === '9015' &&
                                    <div
                                        className={((charge.withholdingCode !== "650") ? "col-md-4" : "col-md-2") + " form-group" + this.validateClass('withholdingCode')}>
                                        <Select
                                            id="withholdingCode"
                                            name="withholdingCode"
                                            value={charge.withholdingCode + '_' + (charge.withholdingCode === '000' ? 0 : charge.percentage)}
                                            clearable={false}
                                            placeholder="Seçiniz..."
                                            noResultsText="Kayıt bulunamadı."
                                            onChange={(e) => e && this.onChangeLineCharge(e.value, j, "withholdingCode")}
                                            options={this.props.withholdingTypes.filter((withholdingType => withholdingType.code !== "000")).map(withholdingType => ({
                                                value: withholdingType.code + '_'    + withholdingType.percentage,
                                                label: withholdingType.code +  ' - ' + (withholdingType.percentage / 10) + "/10" + ' - ' + withholdingType.longName
                                            }))}
                                        />
                                        {this.validateMessage('withholdingCode') !== "" &&
                                        <UncontrolledTooltip placement="right" target={'withholdingCode'} delay={0}>
                                            {this.validateMessage('withholdingCode')}
                                        </UncontrolledTooltip>}
                                    </div>
                                    }
                                    {(charge.taxCode.code !== '9015' || charge.withholdingCode === "650") &&
                                    <div className={(charge.withholdingCode === "650") ? "col-md-2" : "col-md-3"}>
                                        <NumberFormat
                                            id={charge.taxCode.code + '_percentage'}
                                            value={(charge.calculatedBy === "AMOUNT" ? charge.percentage : charge.perUnitAmount)}
                                            allowNegative={false}
                                            suffix={charge.calculatedBy === "AMOUNT" ? '%' : this.props.suffix}
                                            isNumericString={true}
                                            decimalScale={(charge.withholdingCode === "650" ? 0 : 2)}
                                            thousandSeparator={'.'}
                                            decimalSeparator={','}
                                            displayType="input"
                                            disabled={(!(this.props.profileId === "IHRACAT" || this.props.profileId === "YOLCUBERABERFATURA") && charge.exemptionReasonCode) ? true : false}
                                            isAllowed={values => {
                                                return (values.value === "" ? false : true);
                                            }}
                                            renderText={value => {
                                                value.replace(/\./g, ',')
                                            }}
                                            onValueChange={(e) => this.onChangeLineCharge(e.value, j, (charge.calculatedBy === "AMOUNT" ? "percentage" : "perUnitAmount"))}
                                            className="form-control"/>
                                    </div>
                                    }
                                    <div className="col-md-3">
                                        <NumberFormat
                                            id={charge.taxCode.code + '_amount'}
                                            value={charge.amount}
                                            allowNegative={false}
                                            isNumericString={true}
                                            suffix={this.props.suffix}
                                            decimalScale={2}
                                            thousandSeparator={'.'}
                                            decimalSeparator={','}
                                            displayType="input"
                                            disabled={(!(this.props.profileId === "IHRACAT" || this.props.profileId === "YOLCUBERABERFATURA") && charge.exemptionReasonCode) ? true : false}
                                            isAllowed={values => {
                                                return (values.value === "" ? false : true);
                                            }}
                                            renderText={value => {
                                                value.replace(/\./g, ',')
                                            }}
                                            onValueChange={(e) => this.onChangeLineCharge(e.value, j, "amount")}
                                            className="form-control"/>
                                    </div>
                                    {(charge.taxCode.code === '0000' || charge.taxCode.code === '2001' || charge.taxCode.code === '2002'
                                            || charge.taxCode.code === '2003' || charge.taxCode.code === '2004' || charge.taxCode.code === '2005'
                                        || charge.taxCode.code === '0001' || charge.taxCode.code === '3001' || charge.taxCode.code === '3002') &&
                                    <div className="col-md-3">
                                        <input className="form-control"
                                               type="text"
                                               id={charge.taxCode.code + '_reason'}
                                               name={charge.taxCode.code + '_reason'}
                                               value={charge.allowanceReason}
                                               onChange={(e) => this.onChangeAllowanceReason(e.target.value, j)}/>
                                    </div>}
                                    <div className="col-md-1">
                                        {
                                            (charge.taxCode.code !== "0015" && charge.taxCode.code !== "0000") ?
                                                <button type="button"
                                                        style={{
                                                            background: 'linear-gradient(rgba(125, 125, 125, 0.57), rgb(111, 111, 111))',
                                                            marginBottom: '3px'
                                                        }}
                                                        className="Btn temizle"
                                                        onClick={() => this.removeCharge(j)}></button> : ''
                                        }
                                    </div>
                                </div>
                            )}

                            {belgeLine.trdDocBelgeLineCharges.map((charge, j) =>
                                <div key={"key_" + j}>
                                    {(charge.taxCode.code === '0003' || charge.taxCode.code === "0011") &&
                                    <div style={{paddingTop: '30px'}}>
                                        <div className='col-sm-12'>
                                            <div className='row'>
                                                <div className="col-lg-2 col-md-3" style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                                                    <p style={{margin:0}}>Avans Mahsubu</p>
                                                </div>

                                                <div className='col-lg-3 col-md-4' style={{padding: '0 25px 0 10px'}}>
                                                    <NumberFormat
                                                        value={charge.avansMahsubu}
                                                        allowNegative={false}
                                                        suffix={charge.calculatedBy === "AMOUNT" ? '%' : this.props.suffix}
                                                        isNumericString={true}
                                                        thousandSeparator={'.'} decimalSeparator={','}
                                                        displayType="input"
                                                        isAllowed={values => {
                                                            return (values.value === "" ? false : true);
                                                        }}
                                                        renderText={value => {
                                                            value.replace(/\./g, ',')
                                                        }}
                                                        onValueChange={(e) => this.onChangeLineCharge(e.value, j, "avansMahsubu")}
                                                        className="form-control"/>
                                                </div>
                                            </div>
                                        </div>

                                        <div className='col-sm-12'>
                                            <div className='row'>
                                                <div className="col-lg-2 col-md-3" style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                                                    <p style={{margin:0}}>Nakit Teminatı</p>
                                                </div>

                                                <div className='col-lg-3 col-md-4' style={{padding: '0 25px 0 10px'}}>
                                                    <NumberFormat
                                                        value={charge.nakitTeminati}
                                                        allowNegative={false}
                                                        suffix={charge.calculatedBy === "AMOUNT" ? '%' : this.props.suffix}
                                                        isNumericString={true}
                                                        thousandSeparator={'.'} decimalSeparator={','}
                                                        displayType="input"
                                                        isAllowed={values => {
                                                            return (values.value === "" ? false : true);
                                                        }}
                                                        renderText={value => {
                                                            value.replace(/\./g, ',')
                                                        }}
                                                        onValueChange={(e) => this.onChangeLineCharge(e.value, j, "nakitTeminati")}
                                                        className="form-control"/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>}
                                </div>
                            )}

                            <hr/>
                            <div className="row col-sm-12">
                                <div className="col-md-6">
                                    <div className="row">
                                        <label className="col-md-3 col-form-label">KDV İstisna</label>
                                        <div className="col-md-9">
                                            <div className={"form-group" + this.validateClass('kdvExemption')}>
                                                <Select2
                                                    name="kdvExemption"
                                                    id="kdvExemption"
                                                    allowClear={true}
                                                    disabled={this.props.profileId === "IHRACAT" || this.props.profileId === "YOLCUBERABERFATURA" ? true : false}
                                                    placeholder="Seçiniz..."
                                                    value={this.state.kdvExemption === null ? undefined : this.state.kdvExemption}
                                                    style={{width: "100%"}}
                                                    dropdownMenuStyle={{maxHeight: 200, minWidth: 200}}
                                                    optionLabelProp="children"
                                                    optionFilterProp="text"
                                                    showSearch={true}
                                                    notFoundContent="Kayıt bulunamadı"
                                                    getPopupContainer={(node) => {
                                                        return node.parentNode;
                                                    }}
                                                    onChange={(e) => this.onChangeExemption({
                                                        value: e,
                                                        name: "kdvExemption"
                                                    })}>
                                                    {
                                                        getExemptions(this.props.exemptions, "KDV", this.props.documentTypeCode).map(exemption =>
                                                            <Option text={exemption.label} value={exemption.value}
                                                                    key={exemption.value}
                                                                    title={exemption.value}>{exemption.label}</Option>
                                                        )
                                                    }
                                                </Select2>
                                                {this.validateMessage('kdvExemption') !== "" &&
                                                <UncontrolledTooltip placement="right" target={'kdvExemption'}
                                                                     delay={0}>
                                                    {this.validateMessage('kdvExemption')}
                                                </UncontrolledTooltip>}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 ">
                                    <div className="row">
                                        <label className="col-md-3 col-form-label">ÖTV İstisna</label>
                                        <div className="col-md-9">
                                            <div className={"form-group" + this.validateClass('otvExemption')}>
                                                <Select2
                                                    name="otvExemption"
                                                    id="otvExemption"
                                                    allowClear={true}
                                                    disabled={this.props.documentTypeCode === "TEVKIFAT" || this.props.profileId === "IHRACAT" || this.props.profileId === "YOLCUBERABERFATURA" ? true : false}
                                                    placeholder="Seçiniz..."
                                                    value={this.state.otvExemption === null ? undefined : this.state.otvExemption}
                                                    style={{width: "100%"}}
                                                    dropdownMenuStyle={{maxHeight: 200, minWidth: 200}}
                                                    optionLabelProp="children"
                                                    optionFilterProp="text"
                                                    showSearch={true}
                                                    notFoundContent="Kayıt bulunamadı"
                                                    getPopupContainer={(node) => {
                                                        return node.parentNode;
                                                    }}
                                                    onChange={(e) => this.onChangeExemption({
                                                        value: e,
                                                        name: "otvExemption"
                                                    })}>
                                                    {!(this.props.documentTypeCode === "TEVKIFAT" || this.props.profileId === "IHRACAT" || this.props.profileId === "YOLCUBERABERFATURA") &&
                                                    getExemptions(this.props.exemptions, "OTV", this.props.documentTypeCode).map(exemption =>
                                                        <Option text={exemption.label} value={exemption.value}
                                                                key={exemption.value}
                                                                title={exemption.value}>{exemption.label}</Option>
                                                    )
                                                    }
                                                </Select2>
                                                {this.validateMessage('otvExemption') !== "" &&
                                                <UncontrolledTooltip placement="right" target={'otvExemption'}
                                                                     delay={0}>
                                                    {this.validateMessage('otvExemption')}
                                                </UncontrolledTooltip>}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </TabPane>
                        {this.props.isKamu() &&
                        <TabPane tabId="mgmTab">
                            <div className="col-sm-12 row" style={{marginLeft: '25px', marginTop: '20px'}}>
                                <div className="col-sm-12 row">
                                    <label className="col-sm-4 col-form-label">Ürün Menşei* </label>
                                    <div className="col-sm-8">
                                        <div className={"form-group" + this.validateClass('originCountryCode')}>
                                            <Select
                                                id="originCountryCode"
                                                value={originCountryCode}
                                                placeholder="Seçiniz..."
                                                clearable={false}
                                                onChange={(e) => e && this.onChangeMgmFields({
                                                    target: {
                                                        id: "originCountryCode",
                                                        value: e.value
                                                    }
                                                })}
                                                options={this.props.countries.map(country => ({
                                                    value: country.shortName,
                                                    label: country.longNameTr
                                                }))}
                                            />
                                            {this.validateMessage('originCountryCode') !== "" &&
                                            <UncontrolledTooltip placement="right" target="originCountryCode"
                                                                 delay={0}>
                                                {this.validateMessage("originCountryCode")}
                                            </UncontrolledTooltip>}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-12 row">
                                    <label className="col-sm-4 col-form-label">Sınıflama Türü* </label>
                                    <div className="col-sm-8">
                                        <div className={"form-group" + this.validateClass('classificationType')}>
                                            <Select
                                                id="classificationType"
                                                placeholder="Seçiniz..."
                                                value={classificationType}
                                                clearable={false}
                                                onChange={(e) => e && this.onChangeMgmFields({
                                                    target: {
                                                        id: "classificationType",
                                                        value: e.value
                                                    }
                                                })}
                                                options={this.props.classificationTypes.map(classType => ({
                                                    value: classType.name,
                                                    label: classType.name
                                                }))}
                                            />
                                            {this.validateMessage('classificationType') !== "" &&
                                            <UncontrolledTooltip placement="right" target="classificationType"
                                                                 delay={0}>
                                                {this.validateMessage("classificationType")}
                                            </UncontrolledTooltip>}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-12 row">
                                    <label className="col-sm-4 col-form-label">Sınıflama Kodu</label>
                                    <div className="col-sm-8">
                                        <div className="form-group">
                                            <input className="form-control"
                                                   type="text"
                                                   id="classificationValue"
                                                   value={classificationValue}
                                                   onChange={(e) => this.onChangeMgmFields(e)}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </TabPane>
                        }
                        {this.props.profileId === "IHRACAT" &&
                        <TabPane tabId="deliveryTab">
                            <div className="col-sm-12 row" style={{marginLeft: '25px', marginTop: '20px'}}>
                                <div className="col-sm-6 row">
                                    <label className="col-sm-6 col-form-label">Paket/Kutu Numarası</label>
                                    <div className="col-sm-6">
                                        <div className="form-group">
                                            <input className="form-control"
                                                   type="text"
                                                   id="actualPackageId"
                                                   value={deliveryDetail.actualPackageId}
                                                   onChange={(e) => this.onChangeDeliveryDetail(e)}/>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-6 row">
                                    <label className="col-sm-6 col-form-label">Paket/Kutu Türü* </label>
                                    <div className="col-sm-6">
                                        <div className={"form-group" + this.validateClass('actualPackagePTC')}>
                                            <Select
                                                id="actualPackagePTC"
                                                value={deliveryDetail.actualPackagePTC}
                                                clearable={false}
                                                onChange={(e) => e && this.onChangeDeliveryDetail({
                                                    target: {
                                                        id: "actualPackagePTC",
                                                        value: e.value
                                                    }
                                                })}
                                                options={this.props.packageTypeCodes.map(packageTypeCode => ({
                                                    value: packageTypeCode.shortName,
                                                    label: packageTypeCode.longName
                                                }))}
                                            />
                                            {this.validateMessage('actualPackagePTC') !== "" &&
                                            <UncontrolledTooltip placement="right" target="actualPackagePTC"
                                                                 delay={0}>
                                                {this.validateMessage("actualPackagePTC")}
                                            </UncontrolledTooltip>}
                                        </div>
                                    </div>
                                </div>

                                <div className="col-sm-6 row">
                                    <label className="col-sm-6 col-form-label">Paket/Kutu Adedi </label>
                                    <div className="col-sm-6">
                                        <div className={"form-group" + this.validateClass('actualPackageQuantity')}>
                                            <NumberFormat id="actualPackageQuantity"
                                                          value={deliveryDetail.actualPackageQuantity}
                                                          allowNegative={false}
                                                          isNumericString={true}
                                                          decimalScale={2}
                                                          decimalSeparator={','}
                                                          displayType="input"
                                                          data-vdata="number"
                                                          data-vlength="0,45"
                                                          onBlur={(e) => this.validateField(e)}
                                                          onValueChange={(e) => this.onChangeDeliveryDetail({
                                                              target: {
                                                                  value: e.value,
                                                                  id: "actualPackageQuantity"
                                                              }
                                                          })}
                                                          className="form-control"/>
                                            {this.validateMessage('actualPackageQuantity') !== "" &&
                                            <UncontrolledTooltip placement="right"
                                                                 target="actualPackageQuantity" delay={0}>
                                                {this.validateMessage("actualPackageQuantity")}
                                            </UncontrolledTooltip>}
                                        </div>
                                    </div>
                                </div>

                                <div className="col-sm-6 row">
                                    <label className="col-sm-6 col-form-label">Paket/Kutu Markası </label>
                                    <div className="col-sm-6">
                                        <div className="form-group">
                                            <input className="form-control"
                                                   type="text"
                                                   id="packageBrand"
                                                   value={deliveryDetail.packageBrand}
                                                   onChange={(e) => this.onChangeDeliveryDetail(e)}/>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-sm-6 row">
                                    <label className="col-sm-6 col-form-label">Teslimat Şartı* </label>
                                    <div className="col-sm-6">
                                        <div className={"form-group" + this.validateClass('deliveryTerms')}>
                                            <Select
                                                id="deliveryTerms"
                                                value={deliveryDetail.deliveryTerms}
                                                clearable={false}
                                                onChange={(e) => e && this.onChangeDeliveryDetail({
                                                    target: {
                                                        id: "deliveryTerms",
                                                        value: e.value
                                                    }
                                                })}
                                                options={this.props.deliveryTermsCodes.map(deliveryTermsCode => ({
                                                    value: deliveryTermsCode.shortName,
                                                    label: (deliveryTermsCode.shortName + " - " + deliveryTermsCode.longNameEn)
                                                }))}
                                            />
                                            {this.validateMessage('deliveryTerms') !== "" &&
                                            <UncontrolledTooltip placement="right" target="deliveryTerms"
                                                                 delay={0}>
                                                {this.validateMessage("deliveryTerms")}
                                            </UncontrolledTooltip>}
                                        </div>
                                    </div>
                                </div>

                                <div className="col-sm-6 row">
                                    <label className="col-sm-6 col-form-label">GTİP Numarası* </label>
                                    <div className="col-sm-6">
                                        <div className={"form-group" + this.validateClass("gtip")}>
                                            <input className="form-control"
                                                   type="text"
                                                   id="gtip"
                                                   name="gtip"
                                                   maxLength="12"
                                                   data-vdata="gtip"
                                                   data-vlength="12,12"
                                                   onBlur={this.validateField}
                                                   value={deliveryDetail.gtip}
                                                   onChange={(e) => this.onChangeDeliveryDetail(e)}/>
                                            {this.validateMessage('gtip') !== "" &&
                                            <UncontrolledTooltip placement="right" target="gtip" delay={0}>
                                                {this.validateMessage("gtip")}
                                            </UncontrolledTooltip>}
                                        </div>
                                    </div>
                                </div>

                                <div className="col-sm-6 row">
                                    <label className="col-sm-6 col-form-label">Kargo No* </label>
                                    <div className="col-sm-6">
                                        <div className={"form-group" + this.validateClass('shipmentId')}>
                                            <input className="form-control"
                                                   type="text"
                                                   id="shipmentId"
                                                   data-vlength="1,45"
                                                   onBlur={this.validateField}
                                                   value={deliveryDetail.shipmentId}
                                                   onChange={(e) => this.onChangeDeliveryDetail(e)}/>
                                            {this.validateMessage('shipmentId') !== "" &&
                                            <UncontrolledTooltip placement="right" target="shipmentId"
                                                                 delay={0}>
                                                {this.validateMessage("shipmentId")}
                                            </UncontrolledTooltip>}
                                        </div>
                                    </div>
                                </div>

                                <div className="col-sm-6 row">
                                    <label className="col-sm-6 col-form-label">Taşıma Aracı Türü </label>
                                    <div className="col-sm-6">
                                        <div className={"form-group" + this.validateClass('transportMeansTypeCode')}>
                                            <Select
                                                id="transportMeansTypeCode"
                                                value={deliveryDetail.transportMeansTypeCode}
                                                clearable={true}
                                                clearValueText="Boş bırak"
                                                placeholder="Seçiniz"
                                                onChange={(e) => this.onChangeDeliveryDetail({
                                                    target: {
                                                        id: "transportMeansTypeCode",
                                                        value: e !== null ? e.value : e
                                                    }
                                                })}
                                                options={this.props.transportMeansTypeCodes.map(transportMeansTypeCode => ({
                                                    value: transportMeansTypeCode.shortName,
                                                    label: transportMeansTypeCode.longNameTr
                                                }))}
                                            />
                                            {this.validateMessage('transportMeansTypeCode') !== "" &&
                                            <UncontrolledTooltip placement="right"
                                                                 target="transportMeansTypeCode" delay={0}>
                                                {this.validateMessage("transportMeansTypeCode")}
                                            </UncontrolledTooltip>}
                                        </div>
                                    </div>
                                </div>

                                <div className="col-sm-6 row">
                                    <label className="col-sm-6 col-form-label">Teslimat Gönderim Şekli* </label>
                                    <div className="col-sm-6">
                                        <div className={"form-group" + this.validateClass('transportModeCode')}>
                                            <Select
                                                id="transportModeCode"
                                                value={deliveryDetail.transportModeCode}
                                                clearable={false}
                                                onChange={(e) => e && this.onChangeDeliveryDetail({
                                                    target: {
                                                        id: "transportModeCode",
                                                        value: e.value
                                                    }
                                                })}
                                                options={this.props.transportModeCodes.map(transportModeCode => ({
                                                    value: transportModeCode.shortName,
                                                    label: transportModeCode.longName
                                                }))}
                                            />
                                            {this.validateMessage('transportModeCode') !== "" &&
                                            <UncontrolledTooltip placement="right" target="transportModeCode"
                                                                 delay={0}>
                                                {this.validateMessage("transportModeCode")}
                                            </UncontrolledTooltip>}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-6 row">
                                    <label className="col-sm-6 col-form-label">Ülke* </label>
                                    <div className="col-sm-6">
                                        <div className={"form-group" + this.validateClass('country')}>
                                            <Select
                                                id="country"
                                                value={deliveryDetail.country}
                                                placeholder="Seçiniz"
                                                clearable={false}
                                                onChange={(e) => e && this.onChangeDeliveryDetail({
                                                    target: {
                                                        id: "country",
                                                        value: e.value
                                                    }
                                                })}
                                                options={this.props.countries.map(country => ({
                                                    value: country.longNameTr,
                                                    label: country.longNameTr
                                                }))}
                                            />
                                            {this.validateMessage('country') !== "" &&
                                            <UncontrolledTooltip placement="right" target="country" delay={0}>
                                                {this.validateMessage("country")}
                                            </UncontrolledTooltip>}
                                        </div>
                                    </div>
                                </div>

                                <div className="col-sm-6 row">
                                    <label className="col-sm-6 col-form-label">İl* </label>
                                    <div className="col-sm-6">
                                        <div className={"form-group" + this.validateClass('city')}>
                                            <input className="form-control"
                                                   type="text"
                                                   id="city"
                                                   data-vlength="1,45"
                                                   onBlur={this.validateField}
                                                   value={deliveryDetail.city}
                                                   onChange={(e) => this.onChangeDeliveryDetail(e)}/>
                                            {this.validateMessage('city') !== "" &&
                                            <UncontrolledTooltip placement="right" target="city" delay={0}>
                                                {this.validateMessage("city")}
                                            </UncontrolledTooltip>}
                                        </div>
                                    </div>
                                </div>


                                <div className="col-sm-6 row">
                                    <label className="col-sm-6 col-form-label">İlçe* </label>
                                    <div className="col-sm-6">
                                        <div className={"form-group" + this.validateClass('citySubdivion')}>
                                            <input className="form-control"
                                                   type="text"
                                                   id="citySubdivion"
                                                   data-vlength="1,45"
                                                   onBlur={this.validateField}
                                                   value={deliveryDetail.citySubdivion}
                                                   onChange={(e) => this.onChangeDeliveryDetail(e)}/>
                                            {this.validateMessage('citySubdivion') !== "" &&
                                            <UncontrolledTooltip placement="right" target="citySubdivion"
                                                                 delay={0}>
                                                {this.validateMessage("citySubdivion")}
                                            </UncontrolledTooltip>}
                                        </div>
                                    </div>
                                </div>

                                <div className="col-sm-6 row">
                                    <label className="col-sm-6 col-form-label">Cadde </label>
                                    <div className="col-sm-6">
                                        <div className="form-group">
                                            <input className="form-control"
                                                   type="text"
                                                   id="streetName"
                                                   value={deliveryDetail.streetName}
                                                   onChange={(e) => this.onChangeDeliveryDetail(e)}/>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-sm-6 row">
                                    <label className="col-sm-6 col-form-label">Posta Kodu </label>
                                    <div className="col-sm-6">
                                        <div className="form-group">
                                            <input className="form-control"
                                                   type="text"
                                                   id="postalZone"
                                                   value={deliveryDetail.postalZone}
                                                   onChange={(e) => this.onChangeDeliveryDetail(e)}/>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-sm-6 row">
                                    <label className="col-sm-6 col-form-label">Bina Adı </label>
                                    <div className="col-sm-6">
                                        <div className="form-group">
                                            <input className="form-control"
                                                   type="text"
                                                   id="buildingName"
                                                   value={deliveryDetail.buildingName}
                                                   onChange={(e) => this.onChangeDeliveryDetail(e)}/>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-sm-6 row">
                                    <label className="col-sm-6 col-form-label">Bina No </label>
                                    <div className="col-sm-6">
                                        <div className="form-group">
                                            <input className="form-control"
                                                   type="text"
                                                   id="buildingNumber"
                                                   value={deliveryDetail.buildingNumber}
                                                   onChange={(e) => this.onChangeDeliveryDetail(e)}/>
                                        </div>
                                    </div>
                                </div>

                                {(deliveryDetail.deliveryTerms === 'CIF') &&
                                <div className="col-sm-6 row">
                                    <label className="col-sm-6 col-form-label">Navlun</label>
                                    <div className="col-sm-6">
                                        <div className="form-group">

                                            <NumberFormat id="declaredForCarriageValueAmount"
                                                          value={deliveryDetail.declaredForCarriageValueAmount}
                                                          allowNegative={false}
                                                          isNumericString={true}
                                                          allowEmptyFormatting={false}
                                                          decimalScale={9}
                                                          thousandSeparator={'.'}
                                                          decimalSeparator={','}
                                                          displayType="input"
                                                          suffix={this.props.suffix}
                                                          renderText={value => {
                                                              value.replace(/\./g, ',')
                                                          }}
                                                          onValueChange={(e) => this.onValueChangeDeliveryDetail(e, "declaredForCarriageValueAmount")}
                                                          className="form-control"/>
                                        </div>
                                    </div>
                                </div>
                                }
                                {(deliveryDetail.deliveryTerms === 'CIF') &&
                                <div className="col-sm-6 row">
                                    <label className="col-sm-6 col-form-label">Sigorta</label>
                                    <div className="col-sm-6">
                                        <div className="form-group">

                                            <NumberFormat id="insuranceValueAmount"
                                                          value={deliveryDetail.insuranceValueAmount}
                                                          allowNegative={false}
                                                          isNumericString={true}
                                                          allowEmptyFormatting={false}
                                                          decimalScale={9}
                                                          thousandSeparator={'.'}
                                                          decimalSeparator={','}
                                                          displayType="input"
                                                          suffix={this.props.suffix}
                                                          renderText={value => {
                                                              value.replace(/\./g, ',')
                                                          }}
                                                          onValueChange={(e) => this.onValueChangeDeliveryDetail(e, "insuranceValueAmount")}
                                                          className="form-control"/>
                                        </div>
                                    </div>
                                </div>
                                }
                            </div>
                        </TabPane>
                        }
                    </TabContent>
                </Card>
                <ModalFooter className="">
                    <div className="col-sm-2 row ">
                        <button type="button" className="TekBtn vazgec"
                                style={{
                                    background: 'linear-gradient(rgba(125, 125, 125, 0.57), rgb(111, 111, 111))',
                                    padding: '10px 45px 10px 21px'
                                }}
                                onClick={this.isOpen}>İptal
                        </button>
                    </div>
                    <div className="col-sm-1 row"></div>
                    <div className="col-sm-9 row ">
                        <div className="">

                            <button type="button" className="TekBtn kaydet" style={{padding: '10px 45px 10px 21px'}}
                                    disabled={!(this.state.activeTab === "deliveryTab")}
                                    onClick={(e) => this.setDeliveryDetail(e)}>Tümüne Uygula
                            </button>

                            {/*<button type="button" className="TekBtn kaydet" style={{padding: '10px 45px 10px 21px'}}*/}
                            {/*disabled={!(this.state.activeTab === "mgmTab")}*/}
                            {/*onClick={(e) => this.setMgmDetails(e)}>Tümüne Uygula*/}
                            {/*</button>*/}

                        </div>
                        <div className="" style={{marginLeft: '4px', marginRight: '0px'}}>
                            <button type="button" className=" TekBtn kaydet" style={{padding: '10px 42px 10px 10px'}}
                                    onClick={(e) => this.setBelgeLine(e, "close")}>Kaydet ve Kapat
                            </button>
                        </div>
                        <div className="" style={{marginLeft: '4px'}}>

                            <button type="button" className="TekBtn kaydet" style={{padding: '10px 40px 10px 21px'}}
                                    onClick={(e) => this.setBelgeLine(e, "new")}>Kaydet ve Yenİ
                            </button>
                        </div>
                    </div>
                </ModalFooter>
            </Modal>
        );
    }
}

export default BelgeLineModal;

